import { useMutation } from '@tanstack/react-query';
import { IConversation, ImpersonationBroker, IOperationResultNoValue } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Params {
	id: string;
}

export const useUnmarkConversationAsSpamMutation = ({
	onError,
	onSuccess,
	onSettled,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: (data: IConversation, variables: Params) => void;
	onSettled?: () => void;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id }: Params) => {
			return userSession.webServiceHelper.callAsync<IConversation>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `conversation/${id}/spam`,
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess,
		onSettled,
	});
};
